export const GAME_STATUS = {
  open: 0,
  locked: 1,
  rolling: 2,
  complete: 3,
  expired: 4,
}

export const TEAM_COLORS = [
  '#cd412b',
  '#aade4e',
  '#3f99d7',
  '#f1c40f',
]

export const COMMUNISM_COLOR = '#8e918e'

export function parseGame(data) {
  const game = { ...data }

  // handle clock desync
  if (game.lockingAtDifferenceMs) {
    game.lockingAt = Date.now() + game.lockingAtDifferenceMs
  }
  if (game.lastRoundAtDifferenceMs) {
    game.lastRoundAt = Date.now() + game.lastRoundAtDifferenceMs
  }
  if (game.finishedAtDifferenceMs) {
    game.finishedAt = Date.now() + game.finishedAtDifferenceMs
  }
  if (game.expiresAtDifferenceMs) {
    game.expiresAt = Date.now() + game.expiresAtDifferenceMs
  }

  if (game.status === GAME_STATUS.complete) {
    game.canShowWinners = true
    game.round = game.config.rounds.length
  }

  return game
}

export const TEAM_PRESETS = [
  { mode: 'regular', name: '1v1', value: [{ slots: 1 }, { slots: 1 }] },
  { mode: 'regular', name: '1v1v1', value: [{ slots: 1 }, { slots: 1 }, { slots: 1 }] },
  { mode: 'regular', name: '4-way', value: [{ slots: 1 }, { slots: 1 }, { slots: 1 }, { slots: 1 }] },
  { mode: 'team', name: '2v2', value: [{ slots: 2 }, { slots: 2 }] },
  { mode: 'team', name: '1v3', value: [{ slots: 1 }, { slots: 3 }] },
  { mode: 'team', name: '1v1v2', value: [{ slots: 1 }, { slots: 1 }, { slots: 2 }] },
  { mode: 'group', name: '2p', value: [{ slots: 2 }] },
  { mode: 'group', name: '3p', value: [{ slots: 3 }] },
  { mode: 'group', name: '4p', value: [{ slots: 4 }] },
]
